document.addEventListener("DOMContentLoaded", () => {

  const container = document.querySelector(".product__description.rte.quick-add-hidden");

  if (!container) return;

  const elements = Array.from(container.children);

  const sections = [["Description"]];
  let sectionIndex = 0;

  elements.forEach(el => {

    const strong = el.querySelector("strong");

    if (strong) {

      sectionIndex++;

      let title = strong.textContent.trim();

      if (title.endsWith(":")) {
        title = title.slice(0, -1);
      }

      sections[sectionIndex] = [title];

      strong.remove();

      el.textContent = el.textContent.trim();
    }

    if (el.textContent.length > 0) {
      sections[sectionIndex].push(el);
    }

  });


  // Clear container
  container.innerHTML = "";

  // Create wrappers
  const tabWrapper = document.createElement("div");
  tabWrapper.classList.add("product-tabs");

  const tabNav = document.createElement("div");
  tabNav.classList.add("product-tabs-nav");

  const tabContentWrapper = document.createElement("div");
  tabContentWrapper.classList.add("product-tabs-content");

  tabWrapper.appendChild(tabNav);
  tabWrapper.appendChild(tabContentWrapper);

  container.appendChild(tabWrapper);


  sections.forEach((section, index) => {

    const button = document.createElement("button");
    button.className = "tab-button";
    button.textContent = section[0];

    if (index === 0) button.classList.add("active");

    const panel = document.createElement("div");
    panel.className = "tab-panel";

    if (index === 0) panel.classList.add("active");

    section.slice(1).forEach(node => {
      panel.appendChild(node);
    });

    button.addEventListener("click", () => {

      document.querySelectorAll(".tab-button").forEach(btn => btn.classList.remove("active"));
      document.querySelectorAll(".tab-panel").forEach(p => p.classList.remove("active"));

      button.classList.add("active");
      panel.classList.add("active");

    });

    tabNav.appendChild(button);
    tabContentWrapper.appendChild(panel);

  });

});